import React from 'react'
import { Card, Tag, Icon, Empty } from 'antd'
import moment from 'moment'
import * as _ from 'lodash'

import { ComponentExt } from 'util/reactExt'
import Bread from './components/breadCrumb'
import VPlayer from 'components/VPlayer'

import styles from './index.scss'
const types: any = [
  {
    key: '1000101',
    value: 'video',
  },
  {
    key: '1000102',
    value: 'article',
  },
  {
    key: '1000103',
    value: 'audio',
  },
  {
    key: '1000106',
    value: 'video',
  },
]
// 详情页
class ListDetail extends ComponentExt {
  state = {
    details: [],
    tags: [],
    checkedTags: [],
    recommendList: [],
    banner: '',
    activityList: [],
    intro: '',
  }

  async componentDidMount() {
    this.handleFetchData(0)
  }

  handleFetchData = data => {
    const {
      location: { search },
    }: any = this.props
    let id = Number(new URLSearchParams(search).get('id'))

    if (!!data) {
      id = data
    }
    this.setState(
      {
        detail: {},
      },
      () => {
        // tslint:disable-next-line: variable-name
        const label_type = 2
        this.handleFetchActivityIntro()
        this.handleFetchActivityList()
        this.handleFetchActivityBanner()
        this.handleFetchHotArticleList({ label_type })
        this.handleFetchLabelList({ label_type })
        this.handleFetchArticleDetail({ article_id: Number(id) })
      },
    )
  }

  handleClickBreadCrumb = link => {
    if (link) {
      const { history }: any = this.props
      history.push('/team')
    }
  }

  async handleFetchActivityIntro() {
    try {
      const intro = await this.api.family.getFamilyActivityIntroDuce()
      // console.log('intro', intro)
      this.setState({ intro })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityBanner() {
    try {
      const banner = await this.api.family.getFamilyActivityBanner()
      // console.log('banner', banner)
      this.setState({
        banner: banner[0],
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchActivityList() {
    try {
      const {
        data: activityList,
      } = await this.api.family.getFamilyActivityList({})
      this.setState({ activityList })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchArticleDetail(params: { article_id: number }) {
    try {
      const details = await this.api.family.getFamilyArticleDetial(params)
      this.setState({ details, checkedTags: details.data.labels })
      // console.log('details', details)
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchHotArticleList(params: {
    label_type: number
    type?: number
    limit?: number
  }) {
    try {
      const recommendList = await this.api.family.getFamilyHotArticleList(
        params,
      )
      this.setState({
        recommendList,
      })
    } catch (err) {
      console.error(err.message)
    }
  }

  async handleFetchLabelList(params: { label_type: number }) {
    try {
      const tags = await this.api.family.getFamilyLabelList(params)
      this.setState({ tags })
    } catch (err) {
      console.error(err.message)
    }
  }

  handleRenderVDContent = details => (
    <div key={details.id}>
      <Card>
        <div className={styles.title}>
          <h4>{details.title}</h4>
          <p>
            <span>{details.author}</span>
            <span>
              {moment(details.publish_date * 1e3).format('YYYY-MM-DD HH:mm')}
            </span>
            {details.labels.length > 0 &&
              details.labels.map(item => (
                <span key={item.id}>{`#${item.label_name}`}</span>
              ))}
          </p>
        </div>
        <div className={styles.content}>
          <VPlayer
            type={types.filter(v => v.key === details.type)[0].value}
            src={details.content}
            onplay={() => console.log('---play')}
          />
        </div>
      </Card>
      <Card title="视频简介">{details.article_desc}</Card>
    </div>
  )

  handleRenderArticleContent = details => (
    <div key={details.id}>
      <Card>
        <div className={styles.title}>
          <h4>{details.title}</h4>
          <p>
            <span>{details.author}</span>
            <span>
              {moment(details.publish_date * 1e3).format('YYYY-MM-DD HH:mm')}
            </span>
            {details.labels.length > 0 &&
              details.labels.map(item => (
                <span key={item.id}>{`#${item.label_name}`}</span>
              ))}
          </p>
        </div>
        <div
          dangerouslySetInnerHTML={{ __html: details.content }}
          className={styles.content}
        />
      </Card>
    </div>
  )

  handleRenderContent = () => {
    const {
      details: { data },
    }: any = this.state
    let render
    if (_.isEmpty(data)) {
      return (
        <Card>
          <Empty description="暂无数据" />
        </Card>
      )
    }
    render = this.handleRenderArticleContent(data)
    if (data.type === '1000101') {
      render = this.handleRenderVDContent(data)
    }
    return render
  }

  handleRenderTag = () => {
    const { tags, checkedTags } = this.state
    if (_.isEmpty(tags) || _.isEmpty(checkedTags)) {
      return
    }

    return tags.map((itm, idx) => (
      <Tag
        key={itm.id}
        color={_.findIndex(checkedTags, o => o.id === itm.id) > -1 && '#108ee9'}
        onClick={e => this.handleClickList(e, itm, 'tag')}
      >
        {itm.label_name}
      </Tag>
    ))
  }

  handleRenderRecommend = () => {
    const { recommendList } = this.state
    if (_.isEmpty(recommendList)) {
      return
    }
    return _.map(recommendList, (itm, idx) => {
      if (idx === 0) {
        return (
          <div
            className={styles.banner}
            key={itm.id}
            onClick={e => this.handleClickList(e, itm, 'li')}
          >
            <img src={itm.img_url} alt={itm.article_desc} />
            <p>
              {this.handleSliceString(itm.title)}
              {itm.type === '1000101' && <Icon type="play-square" />}
            </p>
          </div>
        )
      }
      return (
        <li key={itm.id} onClick={e => this.handleClickList(e, itm, 'li')}>
          <p>
            {this.handleSliceString(itm.title)}
            {itm.type === '1000101' && <Icon type="play-square" />}
          </p>
        </li>
      )
    })
  }

  handleRenderActivity = () => {
    const {
      activityList,
      banner,
      intro,
    }: { activityList: any; banner: any; intro: string } = this.state
    const len = activityList.length
    if (_.isEmpty(activityList)) {
      return
    }
    return (
      <ul>
        <div
          className={styles.banner}
          onClick={e => this.handleClickList(e, intro, 'actBanner')}
        >
          <img
            height="145"
            width="224"
            src={banner.img_url}
            alt={banner.remark}
          />
        </div>
        {_.map(activityList, (itm, idx) => (
          <li key={idx} onClick={e => this.handleClickList(e, itm.id, 'act')}>
            {this.handleSliceString(itm.title)}
          </li>
        ))}
      </ul>
    )
  }

  handleSliceString = str => {
    let res = str
    if (str && str.length > 30) {
      res = `${str.slice(0, 30)}···`
      return res
    }
    return res
  }

  handleClickList = (e, data, type) => {
    // 阻止冒泡
    e.stopPropagation()
    // console.log('data', data)
    const WINOPEN = url => {
      window.open(window.location.origin + url, '_blank')
    }
    if (type === 'act') {
      WINOPEN(`#/team/actdetail/act?activityId=${data}`)
    } else if (type === 'actBanner') {
      WINOPEN(`#/team/actintro/act?actBanner=${data}`)
    } else if (type === 'tag') {
      WINOPEN(
        `#/team/list/${type}?tagName=${data.label_name}&labelId=${data.id}`,
      )
    }
  }

  render() {
    const { handleRenderContent, handleRenderTag } = this
    const breadCrumb: any = [
      { linkTo: '/team', text: '经传人' },
      { linkTo: '', text: '专题详情' },
    ]
    const mapProps: any = {
      breadCrumb: breadCrumb,
      handleClickBreadCrumb: this.handleClickBreadCrumb,
    }
    return (
      <div className={styles.detail}>
        <Bread {...mapProps} />
        <div className={styles.container}>{handleRenderContent()}</div>
        <div className={styles.others}>
          <div className={styles.contentRtBox}>
            <Card className={styles.activity} title="征文活动">
              {this.handleRenderActivity()}
            </Card>
            <Card title="全部标签">{handleRenderTag()}</Card>
            <Card className={styles.recommend} title="推荐">
              <ul>{this.handleRenderRecommend()}</ul>
            </Card>
          </div>
        </div>
      </div>
    )
  }
}

export default ListDetail
